var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBack({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 18,
    viewBox: "0 0 10 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.144 8.87609L9.50491 16.2352C9.67155 16.4019 9.76518 16.6279 9.76518 16.8636C9.76518 17.0992 9.67155 17.3253 9.50491 17.4919C9.33826 17.6586 9.11223 17.7522 8.87656 17.7522C8.64088 17.7522 8.41486 17.6586 8.24821 17.4919L0.260736 9.50444C0.178086 9.422 0.112513 9.32406 0.0677716 9.21624C0.0230303 9.10842 0 8.99283 0 8.87609C0 8.75936 0.0230303 8.64377 0.0677716 8.53594C0.112513 8.42812 0.178086 8.33018 0.260736 8.24774L8.24821 0.26027C8.41486 0.0936218 8.64088 0 8.87656 0C9.11223 0 9.33826 0.0936218 9.50491 0.26027C9.67155 0.426918 9.76518 0.652942 9.76518 0.888618C9.76518 1.12429 9.67155 1.35032 9.50491 1.51697L2.144 8.87609Z",
    fill: "#152745"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBack);
export default __webpack_public_path__ + "static/media/back.314ebb8187e6c1c5b643b45f03af17c5.svg";
export { ForwardRef as ReactComponent };